import { Pipe, PipeTransform } from '@angular/core';
import { Punk } from '@/models/graph';
import { MarketplaceFilters } from '@/models/pipes';
import { PUNKAUCTION_ADDRESS, TOKENWORKS_ADDRESS } from '@/constants/utils';

@Pipe({
  standalone: true,
  name: 'marketplace'
})

export class MarketplacePipe implements PipeTransform {

  transform(value: Punk[], ...args: (MarketplaceFilters|null)[]): Punk[] {

    if (!value?.length) return [];
    if (!args?.length) return value;

    if (args[0]) { 
      if (args[0] === 'All') return value;
      if (args[0] === 'PunkStrategy') return value
        .filter((item:any) => item.fromAccount?.id === TOKENWORKS_ADDRESS.toLowerCase() 
          || item.toAccount?.id === TOKENWORKS_ADDRESS.toLowerCase() 
          || item.owner?.id === TOKENWORKS_ADDRESS.toLowerCase()
          || item.listing?.punk?.owner?.id === TOKENWORKS_ADDRESS.toLowerCase()
          || item.listing?.fromAccount?.id === TOKENWORKS_ADDRESS.toLowerCase());
      if (args[0] === 'PunkAuction') return value
        .filter((item:any) => item.fromAccount?.id === PUNKAUCTION_ADDRESS.toLowerCase() 
          || item.toAccount?.id === PUNKAUCTION_ADDRESS.toLowerCase() 
          || item.owner?.id === PUNKAUCTION_ADDRESS.toLowerCase()
          || item.listing?.punk?.owner?.id === PUNKAUCTION_ADDRESS.toLowerCase()
          || item.listing?.fromAccount?.id === PUNKAUCTION_ADDRESS.toLowerCase());
      if (args[0] === 'CigStrategy') return [];
      
      return value.filter((item: any) => {
        // For sales data, check the platform field directly
        if (item.platform !== undefined) {
          if (args[0] === 'Native') return !item.platform || item.platform === 'native' || item.platform === 'larvalabs';
          if (args[0] === 'Opensea') return item.platform === 'opensea';
          if (args[0] === 'Blur') return item.platform === 'blur';
          if (args[0] === 'NFTX') return item.platform === 'nftx';
          if (args[0] === 'Gondi') return item.platform === 'gondi';
        }
        
        // For listings data, check the listing.source.domain
        if (item.listing?.source) {
          if (args[0] === 'Native') return !item.listing?.source;
          if (args[0] === 'Opensea') return item.listing?.source?.domain === 'opensea.io';
          if (args[0] === 'Blur') return item.listing?.source?.domain === 'blur.io';
          if (args[0] === 'NFTX') return item.listing?.source?.domain === 'nftx.io';
          if (args[0] === 'Gondi') return item.listing?.source?.domain === 'gondi.xyz';
        }
        
        // If no platform info, show for Native filter
        if (args[0] === 'Native') return true;
        
        return false;
      });
    }

    return value;
  }
}